









































































import { Component, Vue, Prop, Inject } from "vue-property-decorator";
import _ from "@/boot/lodash";
import { IFleetData, IFleetMethods } from "@/components/base/VesselFleet.vue";

@Component
export default class Vessel extends Vue {
  // Injects

  @Inject({ from: "fleetData", default: () => () => undefined })
  public readonly fleetData!: () => IFleetData;

  @Inject({ from: "fleetMethods", default: () => ({}) })
  public readonly $fleetMethods!: IFleetMethods;

  // Props

  @Prop({ default: "div" })
  public readonly type!: string;

  @Prop({ default: false })
  public readonly sortable!: boolean;

  @Prop({ default: false })
  public readonly sortableDisabled!: boolean;

  @Prop({ default: () => vm => vm.$fleetMethods.toggleVessel(vm) })
  public readonly onClick!: Function;

  // Computed

  public get $fleetData() {
    return this.fleetData();
  }

  public get inFleet() {
    return !!this.$fleetData && !!this.$fleetMethods;
  }

  public get index() {
    return this.$_.findIndex(_.get(this.$fleetData, "vessels"), this);
  }

  public get activeIndex() {
    return this.$_.get(this.$fleetData, "activeIndex", -1);
  }

  public get isActive() {
    return this.$_.get(this.$fleetData, "activeVessel") === this;
  }

  public get isBeforeActive() {
    return this.index === this.activeIndex - 1;
  }

  public get isAfterActive() {
    return this.index === this.activeIndex + 1;
  }

  public get isOpen() {
    return this.hasBody ? (this.inFleet ? this.isActive : true) : false;
  }

  public get hasBody() {
    return !!this.$slots.body;
  }

  public get hasFooter() {
    return !!this.$slots.footer;
  }

  // Life-cycle methods

  public created() {
    if (this.inFleet) this.$fleetMethods.registerVessel(this);
  }

  // Methods

  public handleClick() {
    if (this.inFleet) this.onClick(this);
  }
}
